export default __webpack_public_path__ + "static/media/off.a2923da8.png";